import MembershipList from './MembershipList';
export default MembershipList;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipList/components/MembershipList/index.ts